"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.action2 = exports.action = exports.curry2 = exports.curry1 = exports.kalle = exports.nisse = void 0;
exports.ctorsUnion = ctorsUnion;
/**
 * Recursively wrap constructor functions as long as they return other functions
 * until an object is returned, then add type to that object and return it
 */
const wrapIt = (key, fn) => (...args) => {
    const theReturn = fn(...args);
    return typeof theReturn === "function"
        ? wrapIt(key, theReturn)
        : Object.assign({ type: key }, theReturn);
};
/**
 * Create a union type from an object with constructor functions.
 */
function ctorsUnion(ctorsMap) {
    // Transform functions to add key as "type" property in constructed object
    const withType = Object.fromEntries(Object.entries(ctorsMap).map(([key, value]) => [key, wrapIt(key, value)]));
    return withType;
}
// Exmaple usage
const Action = ctorsUnion({
    Foo: (olle) => ({ olle }),
    Bar: (kalle) => ({ kalle }),
    Curry: (a) => (b) => ({ a, b })
});
exports.nisse = Action.Foo("sdaf");
exports.kalle = Action.Bar(1);
exports.curry1 = Action.Curry(1);
exports.curry2 = (0, exports.curry1)(2);
exports.action = Action.Foo("sadfsdf");
exports.action2 = Action.Curry(1)(2);
//# sourceMappingURL=index.js.map